import React from 'react'
import Header from '../Header/Header'
import Main from '../Main/Main'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'


export default function Body() {
    return (
        <>
            <Header/>
            <Navbar/>
            <Main/>
            <Footer/>
        </>
    )
}
